<template>
  <div class="card-padding">
    <div
      v-if="headerTitle"
      class="header-common view-flex view-flex-bottom"
    >
      <div class="main">
        {{ headerTitle.main }}
      </div>
      <div
        class="subtitle"
        @click="handleRoute"
      >
        {{ headerTitle.sub }}
      </div>
    </div>
    <br>
    <el-row
      v-if="overviewData"
      :gutter="40"
    >
      <el-col :span="5">
        <div class="block">
          <div class="top">
            <span>销售实付收入(元)&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <div class="tip-content">
                  今日实时订单实付金额（减去运费，微信代金券）；昨日订单实付金额（减去运费，微信代金券）
                </div>
              </div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="mid">
            {{ money((overviewData && overviewData.today && overviewData.today.pay_fee) || 0) }}
          </div>
          <div class="bottom">
            昨日
            {{ money(overviewData && overviewData.yestoday && overviewData.yestoday.pay_fee) || 0 }}
          </div>
        </div>
      </el-col>
      <el-col
        :span="5"
      >
        <div class="block">
          <div class="top">
            <span>交易笔数&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <div class="tip-content">
                  今日实时实付订单笔数；昨日订单实付订单笔笔数
                </div>
              </div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="mid">
            {{ (overviewData && overviewData.today && overviewData.today.pay_num) || 0 }}
          </div>
          <div class="bottom">
            昨日
            {{ (overviewData && overviewData.yestoday && overviewData.yestoday.pay_num) || 0 }}
          </div>
        </div>
      </el-col>
      <el-col
        :span="5"
      >
        <div class="block">
          <div class="top">
            <span>客单价(元)&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <div class="tip-content">
                  今日每个会员的平均成交金额;昨日每个会员的平均成交金额
                </div>
              </div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="mid">
            {{ money(overviewData && overviewData.today && overviewData.today.customer) || 0 }}
          </div>
          <div class="bottom">
            昨日
            {{
              money(overviewData && overviewData.yestoday && overviewData.yestoday.customer) || 0
            }}
          </div>
        </div>
      </el-col>
      <el-col
        :span="5"
      >
        <div class="block">
          <div class="top">
            <span>退款金额(元)&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <div class="tip-content">
                  今日实时退款订单金额；昨日退款金额
                </div>
              </div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="mid">
            {{ money(overviewData && overviewData.today && overviewData.today.refund_fee) || 0 }}
          </div>
          <div class="bottom">
            昨日
            {{
              money(overviewData && overviewData.yestoday && overviewData.yestoday.refund_fee) || 0
            }}
          </div>
        </div>
      </el-col>
      <el-col
        :span="4"
      >
        <div class="block">
          <div class="top">
            <span>折扣率&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <div class="tip-content">
                  今日实时实付订单合计金额（减去运费，微信代金券）与订单商品合计原价比较折扣率；昨日实付订单合计金额（减去运费，微信代金券）与订单商品合计原价比较折扣率
                </div>
              </div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="mid">
            {{ (overviewData && overviewData.today && overviewData.today.disrate) || 0 }}%
          </div>
          <div class="bottom">
            昨日
            {{ (overviewData && overviewData.yestoday && overviewData.yestoday.disrate) || 0 }}%
          </div>
        </div>
      </el-col>
    </el-row>
    <br>

    <el-row :gutter="40">
      <el-col
        :span="5"
      >
        <div class="block">
          <div class="top">
            <span>新增客户数&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <div class="tip-content">
                  今日实时导购添加为好友的且数据库中未有记录的外部联系人；昨日导购添加为好友的且数据库中未有记录的外部联系人
                </div>
              </div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="mid">
            {{ (overviewData && overviewData.today && overviewData.today.new_user) || 0 }}
          </div>
          <div class="bottom">
            昨日
            {{ (overviewData && overviewData.yestoday && overviewData.yestoday.new_user) || 0 }}
          </div>
        </div>
      </el-col>
      <el-col
        :span="5"
      >
        <div class="block">
          <div class="top">
            <span>新增会员数&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <div class="tip-content">
                  今日实时导购引导客户转化为会员的客户数；昨日导购引导客户转化为会员的客户数，会员注册时间需大于添加好友时间
                </div>
              </div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="mid">
            {{ (overviewData && overviewData.today && overviewData.today.login_user) || 0 }}
          </div>
          <div class="bottom">
            昨日
            {{ (overviewData && overviewData.yestoday && overviewData.yestoday.login_user) || 0 }}
          </div>
        </div>
      </el-col>
      <el-col
        :span="5"
      >
        <div class="block">
          <div class="top">
            <span>实付会员数&nbsp;</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
            >
              <div slot="content">
                <div class="tip-content">
                  今日实时实付下单的会员数(去重)；昨日实付下单的会员数(去重)
                </div>
              </div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </div>
          <div class="mid">
            {{ (overviewData && overviewData.today && overviewData.today.pay_user) || 0 }}
          </div>
          <div class="bottom">
            昨日
            {{ (overviewData && overviewData.yestoday && overviewData.yestoday.pay_user) || 0 }}
          </div>
        </div>
      </el-col>
      <!-- <el-col :span="5"
        ><div class="block">
          <div class="top">
            <span>流失客户数&nbsp;</span>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                <div class="tip-content">
                  今日实时删除导购好友(且没有与其他导购有好友关系)的客户数；昨日删除导购好友(且没有与其他导购有好友关系)的客户数
                </div>
              </div>
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
          <div class="mid">
            {{ (overviewData && overviewData.today && overviewData.today.outflow_user) || 0 }}
          </div>
          <div class="bottom">
            昨日
            {{ (overviewData && overviewData.yestoday && overviewData.yestoday.outflow_user) || 0 }}
          </div>
        </div></el-col
      > -->
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    headerTitle: {
      type: Object,
      default: () => {}
    },
    datastatics: {
      type: Array,
      default: () => []
    },
    lineChart: {
      type: Boolean
    },
    viewUrl: {
      type: String
    },
    overviewData: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    console.log(this.overviewData)
  },
  methods: {
    handleRoute: function () {
      if (!this.viewUrl) {
        return
      }
      this.$router.push(`${this.viewUrl}`)
    },
    money (num) {
      return `${(num / 100).toFixed(2)}`
    }
  }
}
</script>

<style lang="scss" scoped>
.card-padding {
  padding: 30px;
  background: #fff;
  margin-bottom: 20px;
  .body {
    display: flex;

    .col {
      width: 33.3333%;
      margin-top: 30px;
    }
  }

  &.height190px {
    height: 190px;
  }

  .header-common {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .subtitle {
      margin-left: 30px;
      font-size: 14px;
      color: grey;
      cursor: pointer;
    }
  }
  &.histogram {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .sub {
      font-size: 12px;
      color: grey;
    }
    .body {
      margin-top: 36px;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .card-padding {
    padding-bottom: 30px;

    .body {
      display: flex;

      .col {
        margin-top: 20px;
      }
    }

    .header-common {
      .main {
        font-size: 14px;
      }
      .subtitle {
        font-size: 12px;
      }
    }
  }
}
.top {
  color: #909399;
  font-size: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
}
.mid {
  font-size: 18px;
  color: #333;
}
.bottom {
  font-size: 12px;
  color: #909399;
}
.tip-content {
  max-width: 250px;
  line-height: 18px;
}
</style>
